import { Injectable } from '@angular/core';
import { Command, DeleteCommand, FilteredCommand, MultiselectCommand, standardCommand } from './../../model/command';

@Injectable()
export class CommandFactoryService<TContext = any, TItem = any> {
  constructor() {}

  createContextCommand(id: string, context: TContext, contextId?: string): Command<TContext> {
    let command: Command<TContext>;
    if (id === standardCommand.delete) {
      command = new DeleteCommand<TItem>(id, contextId);
    } else {
      command = new Command<TContext>(id, contextId);
    }
    command.context = context;
    return command;
  }

  createFilteredCommand(id: string, excludedIds: string[], includedIds: string[], totalAffectedItemsControlValue: number) {
    return new FilteredCommand(id, excludedIds, includedIds, totalAffectedItemsControlValue);
  }

  createMultiselectCommand(id: string, items: TItem[], itemsSource: TItem[], contextId?: string): MultiselectCommand<TItem> {
    return new MultiselectCommand(id, items, itemsSource, contextId);
  }
}
